"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var employee_1 = tslib_1.__importDefault(require("./employee"));
var eeoclass_1 = tslib_1.__importDefault(require("./eeoclass"));
var currency_1 = tslib_1.__importDefault(require("./currency"));
var address_1 = tslib_1.__importDefault(require("./address"));
var state_1 = tslib_1.__importDefault(require("./state"));
var flsatype_1 = tslib_1.__importDefault(require("./flsatype"));
var legislativetype_1 = tslib_1.__importDefault(require("./legislativetype"));
var laborunionlocal_1 = tslib_1.__importDefault(require("./laborunionlocal"));
var occcode_1 = tslib_1.__importDefault(require("./occcode"));
var agreement_1 = tslib_1.__importDefault(require("./agreement"));
var department_1 = tslib_1.__importDefault(require("./department"));
var schedule_1 = tslib_1.__importDefault(require("./schedule"));
var employeetype_1 = tslib_1.__importDefault(require("./employeetype"));
var wcclassification_1 = tslib_1.__importDefault(require("./wcclassification"));
var project_1 = tslib_1.__importDefault(require("./project"));
var fee_1 = tslib_1.__importDefault(require("./fee"));
var feegroup_1 = tslib_1.__importDefault(require("./feegroup"));
var file_1 = tslib_1.__importDefault(require("./file"));
var AssignmentResource = /** @class */ (function (_super) {
    tslib_1.__extends(AssignmentResource, _super);
    function AssignmentResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssignmentResource.endpoint = '/assignments';
    AssignmentResource.MODEL_NAME = 'assignment';
    AssignmentResource.related = {
        employee: employee_1.default,
        eeo_class: eeoclass_1.default,
        currency: currency_1.default,
        address: address_1.default,
        hire_state: state_1.default,
        flsa_type: flsatype_1.default,
        legislative_type: legislativetype_1.default,
        labor_union_local: laborunionlocal_1.default,
        occ_code: occcode_1.default,
        agreement: agreement_1.default,
        department: department_1.default,
        schedule: schedule_1.default,
        employee_type: employeetype_1.default,
        wc_classification: wcclassification_1.default,
        project: project_1.default,
        fees: fee_1.default,
        fee_groups: feegroup_1.default,
        files: file_1.default,
    };
    return AssignmentResource;
}(base_1.default));
exports.default = AssignmentResource;
//# sourceMappingURL=assignment.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/assignment.js
// module id = Pyfk
// module chunks = 0